import React, { Component } from 'react';
import Section from '../layout/Section';
import ListadoClientes from '../subcomponents/ListadoClientes';
import Testimonials from '../subcomponents/Testimonials';
import image from '../assets/img/vector/clientes.svg';
import SectionContainer from '../subcomponents/SectionContainer';
import ImageText from '../subcomponents/ImageText';

class Clientes extends Component {
  componentDidMount() {
    document.title = 'Clientes - Insacom';
  }
  render() {
    return (
      <Section backgroundColor="white" no-contact>
        <SectionContainer backgroundColor="#b0d2df" paddingBottom="0px">
          <ImageText
            image={image}
            title="Clientes"
            description="Hace más de 10 años que Insacom presta servicios a empresas de diverso tamaño que se especializan en diferentes rubros, manteniendo una relación de confianza a largo plazo.
            A continuación presentamos algunos de nuestros clientes."></ImageText>
        </SectionContainer>
        <SectionContainer>
          <div className="g-overflow-hidden">
            <div className="row text-center mx-0 g-ml-minus-1 g-mb-minus-1">
              <ListadoClientes />
            </div>
          </div>
        </SectionContainer>
        <Testimonials />
      </Section>
    );
  }
}

export default Clientes;



// WEBPACK FOOTER //
// ./src/sections/Clientes.js